export const contactFormUrl = "https://subscribe.sph.com.sg/contact-us/";
export const newspostUrl = "https://newspost.newslink.sg/";

export const sphText = "Copyright SPH Media. All rights reserved.";
export const nonSphText =
  "Share with us your feedback on BT's products and services";
